import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared';

/**
 * Lease apply candidates request.
 */
export class LeaseMeteringApplyRequest {
  leasedBy!: string;
  @TransformDate()
  leasedUntil!: Date;
  @TransformInt()
  batch!: number;
}
